import { Routes } from '@angular/router';

export const CUSTOMERS_ROUTES: Routes = [
  {
    path: 'customers',
    loadComponent: () =>
      import('./customers-list/customers-list.component')
        .then(m => m.CustomersListComponent),
  }
];
